import Swiper, { EffectFade, Pagination, Autoplay } from "swiper";
import setVideoModal from "./setVideoModal";

const setHeroSlider = () => {
  const target = document.getElementById('js-hero-slider')
  if (!target) return false;

  let swiper;

  const slides = target.querySelectorAll('.swiper-slide');
  if (slides.length > 1) {
    const pagination = document.getElementById('js-hero-slider-pagination');
    swiper = new Swiper(target, {
      modules: [EffectFade, Pagination, Autoplay],
      loop: true,
      slidesPerView: 1,
      autoplay: {
        delay: 8000,
        disableOnInteraction: false,
      },
      speed: 800,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      pagination: {
        el: pagination,
      }
    });

    pagination?.classList.add('is-show');
  }

  target.classList.add('is-init');
  setVideoModal(swiper);
};

export default setHeroSlider;